const header = document.querySelector('.header');
const headerHeight = header.clientHeight;

function handleScroll() {
  const scrollY = window.scrollY || window.pageYOffset;

  if (scrollY >= headerHeight / 2) {
    header.setAttribute('data-bg', 'true');
  } else {
    header.removeAttribute('data-bg');
  }
}

handleScroll();

window.addEventListener('scroll', handleScroll);

const headerSearchIcon = document.querySelector('.header__search__icon');

headerSearchIcon?.addEventListener('click', (e) => {
  e.preventDefault();

  const searchForm = document.querySelector('.header__search__form');

  if (searchForm.classList.contains('form-visible')) {
    searchForm.submit();
  }

  searchForm.classList.toggle('form-visible');
});

const burger = document.querySelector('.header__burger');

burger.addEventListener('click', () => {
  const isDeployed = header.getAttribute('data-deployed') === 'true';
  header.setAttribute('data-deployed', isDeployed ? 'false' : 'true');
  document.querySelector('body').classList.toggle('no-scroll', !isDeployed);
});

const menusItemsWithChildren = document.querySelectorAll(
  '.header__menu .menu-item-has-children'
);

menusItemsWithChildren.forEach((item) => {
  item.addEventListener('click', (e) => {
    if (window.innerWidth < 992) {
      e.preventDefault();
      e.stopPropagation();
      item.classList.toggle('open');
    }
  });
});

const innerItems = document.querySelectorAll(
  '.header__menu .menu-item-has-children .sub-menu'
);

innerItems.forEach((innerItem) => {
  innerItem.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});
